import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=1fdb1ee4&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=1fdb1ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdb1ee4",
  null
  
)

export default component.exports